export default [
  {
    path: '/store/step1',
    name: 'step1',
    meta: {
      title: '入驻流程'
    },
    component: () => import('@/views/seller/apply/step1.vue')
  }, {
    path: '/store/step2',
    name: 'step2',
    meta: {
      title: '商家入驻申请'
    },
    component: () => import('@/views/seller/apply/step2.vue')
  }, {
    path: '/store/step3',
    name: 'step3',
    meta: {
      title: '店铺开通'
    },
    component: () => import('@/views/seller/apply/step3.vue')
  }, {
    path: '/store/step4',
    name: 'step4',
    meta: {
      title: '店铺经营信息'
    },
    component: () => import('@/views/seller/step4.vue')
  }, {
    path: '/store/step5',
    name: 'step5',
    meta: {
      title: '店铺开通'
    },
    component: () => import('@/views/seller/step5.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/step.js